import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';
import ButtonWithChildren from '../ButtonWithChildren';
import './SetAlertButton.scss';

export default class SetAlertButton extends React.PureComponent {
    constructor(props) {
        super();

        this.state = {
            location: '',
        };
    }

    static propTypes = {
        /*
            On Click Functions
        */
        onClick: PropTypes.func,
        /*
            Whether it is actor or not
        */
        active: PropTypes.bool,
    };

    static defaultProps = {};

    componentDidMount() {
        this.setState({ location: window.location });
    }

    render() {
        let alertButtonIcon = <i className="material-icons">add_alert</i>;
        let alertButtonText = 'Add Alert';
        let borderClass = 'dashed-purple';

        if (this.props.active) {
            alertButtonIcon = <i className="material-icons">notifications</i>;
            alertButtonText = 'Alerts On';
            borderClass = 'solid-white';
        }

        return (
            <div className="component-Input-ButtonWithChildren-SetAlertButton">
                <PageConsumer>
                    {(context) =>
                        context.wrapAuth(
                            'alert-button',
                            <ButtonWithChildren
                                onClick={() => {
                                    context.isLoggedIn()
                                        ? this.props.onClick()
                                        : null;
                                }}
                                className={`${borderClass} alertButton`}
                                disabled={this.props.active}
                            >
                                {alertButtonIcon}
                                {alertButtonText}
                            </ButtonWithChildren>,
                            { login_trigger: 'set-job-alert' }
                        )
                    }
                </PageConsumer>
            </div>
        );
    }
}
